<template>
  <vue-scroll class="page-payment-provider">
    <div class="page-header">
      <h1><i :class="'mdi mdi-'+ $route.meta.icon"></i> {{ $route.name }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-base card-shadow--medium p-30">
      <el-row :gutter="50">
        <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="9" :xl="9">
          <h2>Datos de registro</h2>
          <el-form
            :model="form"
            ref="form"
            status-icon
            label-width="150px"
            size="medium"
            class="demo-form"
            :rules="rules"
            :label-position="(innerWidth > 1300) ? 'left' : 'top'"
            v-loading="loadingForm"
          >
            <el-form-item label="Nombre" prop="name">
              <el-input
                v-model="form.name"
                autocomplete="off"
                placeholder="Nombre de la zona"
                clearable
              ></el-input>
            </el-form-item>
            
            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm('form')"
                :loading="loading"
                icon="el-icon-check"
                v-if="!edit"
              >Guardar</el-button>
              <el-button
                type="warning"
                @click="submitForm('form')"
                :loading="loading"
                icon="el-icon-edit"
                v-else
              >Actualizar</el-button>
              <el-button @click="resetForm('form')" icon="el-icon-close">Cancelar</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <!-- grid -->
        <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="15" :xl="15">
          <el-table
            :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%; margin-top:20px;"
            height="500"
            v-loading="loadingTable"
          >
            <el-table-column label="Zona" prop="name"></el-table-column>
            <el-table-column align="right">
              <template slot="header">
                <el-input v-model="search" size="mini" placeholder="Digite el nombre" />
              </template>
              <template slot-scope="scope">   
                <el-tooltip class="item" effect="dark" content="Editar" placement="top">
                  <el-button
                    size="mini"
                    type="warning"
                    @click="handleEdit(scope.$index, scope.row)"
                    icon="el-icon-edit"
                    circle
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Eliminar" placement="top">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    icon="el-icon-delete"
                    circle
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </vue-scroll>
</template>

<script>
import { store, update, getAll, getById, deleteData } from "@/api/zone";
export default {
  name: "Store",
  data() {
    return {
      loading: false,
      loadingForm: false,
      loadingTable: false,
      modalOpen: false,
      edit: false,
      innerWidth: 0,
      labelPosition: "top",
      form: {
        id: "",
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
      },
      tableData: [],
      search: "",
    };
  },
  methods: {
    resizeOpenNav() {
      this.innerWidth = window.innerWidth;
    },
    submitForm(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.edit) {
            this.updateForm();
          } else {
            this.saveForm();
          }
        } else {
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    saveForm() {
      var datas = this.setDatas()
      store(datas)
        .then(({ data }) => {
          this.loading = false;
          if (data.code === 200) {
            this.getTableData();
            this.resetForm("form");
          } else {
            this.$message.error("Error! " + data.error.errorInfo[2]);
          }
        })
        .catch(function (error) {
          this.loading = false;
          console.log("Err: ", error);
        });
    },
    updateForm() {
      var datas = this.setDatas()
      update(datas)
        .then(({ data }) => {
          this.loading = false;
          if (data.code === 200) {
            this.getTableData();
            this.resetForm("form");
          } else {
            this.$message.error("Error! " + data.error.errorInfo[2]);
          }
        })
        .catch(function (error) {
          this.loading = false;
          console.log("Err: ", error);
        });
    },
    setDatas(){
      return {
        id: this.form.id,
        name: this.form.name,
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.loading = false;
      this.edit = false;
    },
    getTableData() {
      this.loadingTable = true;
      getAll()
        .then(({ data }) => {
          this.loadingTable = false;
          this.tableData = data;
        })
        .catch(function (error) {
          this.loadingTable = false;
          console.log(error);
        });
    },

    // table
    handleEdit(index, row) {
      let me = this;
      this.loadingForm = true;
      getById(row.id)
        .then(({ data }) => {
          this.edit = true;
          this.loadingForm = false;
          this.form = {
            id: data.id,
            name: data.name,
          };
        })
        .catch(function (error) {
          console.log("Err: ", error);
        });
    },
    handleDelete(index, row) {
      this.$confirm("Desea eliminar este registro?", "Atención!", {
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          deleteData(row.id)
            .then(({ data }) => {
              this.loading = false;
              if (data.code === 200) {
                this.getTableData();
                this.resetForm("form");
              } else {
                this.$message.error("Error! " + data.error.errorInfo[2]);
              }
            })
            .catch(function (error) {
              this.loading = false;
              console.log("Err: ", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Operación Cancelada",
          });
        });
    },
  },
  created() {
    this.getTableData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeOpenNav);
  },
};
</script>

<style lang="scss">
.el-select {
  width: 100%;
}
.el-icon-circle-check {
  color: #1cc529;
}
</style>
